import React from "react";

import "../debtLoadCalculation.scss";

export function FormSection({ title, questionNumber, description, children, className = "entry-wrapper" }) {
  return (
    <div className={className}>
      <h4>
        {questionNumber}. {title}
      </h4>
      {description && <p className="form-element-label">{description}</p>}
      {children}
    </div>
  );
}
